// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			//resizeWindow();
		});
		//resizeWindow();

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		var augdate = new Date(2021,7,13);
		var today = new Date();
		var demindate = 0;
		if( augdate < today ){
			demindate = today
		}else{
			demindate = augdate
		}
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "mm-dd-yy";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: demindate,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
				
				var chkInVal = $('#CheckIn').val();
				var spltdate = chkInVal.split('-');
				$('#CheckIn-real').val(spltdate[2] + '-' + spltdate[0] + '-' + spltdate[1]);

				var chkOutVal = $('#CheckOut').val();
				var spltdate = chkOutVal.split('-');
				$('#CheckOut-real').val(spltdate[2] + '-' + spltdate[0] + '-' + spltdate[1]);
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				var chkOutVal = $('#CheckOut').val();
				var spltdate = chkOutVal.split('-');
				$('#CheckOut-real').val(spltdate[2] + '-' + spltdate[0] + '-' + spltdate[1]);
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
	};
	
	window.addEventListener('scroll', function(){
		scrollW();
	});

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/* Navigation menu */
var navbutton = document.querySelectorAll('.header__hamburger');
navbutton.forEach( (t) => {
	t.addEventListener('click', function(e){
		e.preventDefault();
		var deheader = document.querySelector('#header');
		deheader.classList.toggle('open-nav');
		document.querySelector('nav.buttons').classList.toggle('open-nav');
		console.log(deheader.classList.contains('open-nav'));
		if( deheader.classList.contains('open-nav') ){
			document.querySelector('.header__hamburger .button__btn__label').innerHTML = 'Close';
		}else{
			document.querySelector('.header__hamburger .button__btn__label').innerHTML = 'Menu';
		}
	}); 
});

var navbutton = document.querySelector('.header__booking__btn');
navbutton.addEventListener('click', function(e){
	e.preventDefault();
	var deheader = document.querySelector('#header');
	deheader.classList.toggle('open-booking');
});
var rellaX = document.querySelector('.rellax');
if(rellaX){
	var rellax = new Rellax('.rellax', {
		breakpoints:[768]
	});
}
$('.lazyload').on('load',function(){
	rellax.refresh();
	var slider = $(this).closest('.sym-slides');
	setTimeout(function(){ 
		slider.slick('unslick');
		slider.slick();
	}, 1000);
});

/* Slider Quad */
$('.slider-with-pager').on('afterChange', function(a,b,c){
	var pager = $(this).next();
	if(pager){
		pager.find('.slider-quad-white__curent').text( c + 1);
	}
});

/* Gallery Quad */
$('.home-gallery__slider').on('init', function(a,b,c){
	setTimeout(function(){
		rellax.refresh();
	}, 1000);
}).on('afterChange', function(a,b,c){
	$('.home-gallery__curent').text( c + 1);
});

/* List Item Quad */
$('.list__item__img .sym-slides').on('afterChange', function(a,b,c){
	var pager = $(this).closest('.list__item');
	pager.find('.list__item__curent').text( c + 1);
});

$('.slide-with-pager').on('afterChange', function(a,b,c){
	var deid = this.dataset.id;
	document.querySelector('.current-' + deid).innerHTML = c + 1;
});

/* custom slider for booking direct benefits */
function changeBdbSlide(){
	var deli = document.querySelector('.intro-content-home__bdb li.active');
	deli.classList.remove('active');
	var denext = deli.nextElementSibling;
	if(denext){
		denext.classList.add('active');
	}else{
		document.querySelector('.intro-content-home__bdb > ul > li:first-child').classList.add('active');
	}
}
var introhome = document.querySelector('.intro-content-home__bdb > ul > li');

if(introhome){
	introhome.classList.add('active');
	setInterval(function(){ changeBdbSlide() }, 3500);
}

/* Scroll to Button */
$('.scrollto').on('click', function(){
	var destiny = $(this).attr('href');
	var toppos = $(destiny).offset().top - 90
	$('html,body').animate({scrollTop: toppos}, 1000);
});

// TABS ROOMS
var firstTab = document.querySelector('.list__tabs__item:first-child a');
//var firstTab = document.querySelector('#tab-ShoppingampDining a');
if (firstTab) {
	firstTab.classList.add('active');
	var filterFirts = firstTab.getAttribute("data-target");
	var sectionFirst = firstTab.closest('section');

	sectionFirst.querySelectorAll('.list__item').forEach((allDivsFirst) => {
		allDivsFirst.classList.remove('list__item__hide');
	});

	var hideSelectorsFirst = '.list__item:not(' + filterFirts + ')';
	sectionFirst.querySelectorAll(hideSelectorsFirst).forEach((hideDivsFirst) => {
		hideDivsFirst.classList.add('list__item__hide');
		document.querySelector('.list__ofrooms').appendChild(hideDivsFirst);
	});

	var tabbuttons = document.querySelectorAll('.list__tabs__btn');
	var tc = 0;

	for (tc; tc < tabbuttons.length; tc++) {
		tabbuttons[tc].addEventListener('click', function () {

			if (!this.classList.contains('active')) {

				tabbuttons.forEach((tabbuttons) => { tabbuttons.classList.remove('active') })

				this.classList.add('active');
				var filterdis = this.getAttribute("data-target");
				var section = this.closest('section');

				section.querySelectorAll('.list__item').forEach((allDivs) => {
					allDivs.classList.remove('list__item__hide');
				})

				if (filterdis) {
					var hideSelectors = '.list__item:not(' + filterdis + ')';
					section.querySelectorAll(hideSelectors).forEach((hideDivs) => {
						hideDivs.classList.add('list__item__hide');
						document.querySelector('.list__ofrooms').appendChild(hideDivs);
					});
				}

				//Toggle animations first quad
				var firtsQuad = document.querySelector('.list__item' + filterdis);
				firtsQuad.querySelectorAll('.animate-fade').forEach((animated) => {
					animated.classList.add('fade-in', 'visible');
				});
			}
		});
	}
}


/* Hide second gdpr option */
$('#form_id-589-yes-signup-formemail-signup, #form_id-590-yes-signup-formemail-signup, #form_id-587-yes-signup-formemail-signup').closest('.field.gdpr').remove();


